import type { FC } from 'react';

import { HelpChapterProps } from '../../../../api/fetchers/help/fetcher';
import { IconButton, Icons } from '../../../controls/iconButton/IconButton';
import { NavButton } from '../../../nav/navButton/index';
import { L12nText } from '../../../text/L12nText';
import { HelpComponentWrapper } from '../../utils/HelpComponentWrapper';
import { HelpText } from '../../utils/HelpText';

export const HelpChapterNavigationControls: FC<HelpChapterProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText>{String(content.allGames)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <NavButton>
          <L12nText tk="LOBBY" />
        </NavButton>
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.chatButton)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Chat} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.liveSupport)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Support} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.chatMessages)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.volumeButton)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.SoundOn} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.historyButtonNoOlderTab)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.History} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.gameRound)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.gameHelp)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Help} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.settingsButton)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Settings} />
      </HelpComponentWrapper>
      <ul>
        <li>{String(content.videoStream)}</li>
        <li>{String(content.videoQuality)}</li>
        <li>{String(content.soundEffects)}</li>
      </ul>
      <p>
        <HelpText>{String(content.classicView)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.Video} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.lowVideoResolution)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.fullScreen)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <IconButton icon={Icons.FullscreenEnter} />
      </HelpComponentWrapper>
    </div>
  );
};
